import React from "react"
import ContentLayoutHeader from "../../../components/layouts/ContentLayoutHeader.layout"
import PrimaryButton from "../../../components/molecules/buttons/PrimaryButton.molecule"
import { useNavigate } from "react-router-dom"
import { AppRoutes } from "../../../consts/appRoutes.consts"
import { SISU_CLIENTS } from "../../../consts/modules/clients.consts"
import { SURVEY_IDS } from "../../../consts/modules/survey.consts"

const FormHeaderClient = ({ isCreate = true, selectedClient }) => {
  const navigate = useNavigate()
  let label
  if (isCreate) {
    label = "Crear"
  } else {
    label = "Consulta de"
  }
  const redirectToSurvey = (surveyId = SURVEY_IDS.BLOCK_SURVEY) => {
    const token = btoa(
      JSON.stringify({
        clientId: selectedClient.id,
        surveyId,
      })
    )

    const basePath = AppRoutes.surveys.survey
    const surveyUrl = basePath.replace(":token", token)

    window.open(surveyUrl, "_blank", "noopener,noreferrer")
  }
  return (
    <ContentLayoutHeader
      title={`${label} cliente`}
      className="mb-4"
      goBack
      extraContent={
        Object.keys(selectedClient).includes("id") &&
        !SISU_CLIENTS.includes(
          selectedClient?.clientId || selectedClient?.id
        ) &&
        !isCreate && (
          <>
            <PrimaryButton
              label="Encuesta de ciclo"
              className="budget-redirect-button text-base white-space-nowrap header-client-button"
              icon="pi pi-external-link text-xl"
              btnType="outlined"
              onClick={() => redirectToSurvey(SURVEY_IDS.CYCLE_SURVEY)}
            />
            <PrimaryButton
              label="Encuesta de bloque"
              className="budget-redirect-button text-base white-space-nowrap header-client-button"
              icon="pi pi-external-link text-xl"
              btnType="outlined"
              onClick={() => redirectToSurvey(SURVEY_IDS.BLOCK_SURVEY)}
            />

            <PrimaryButton
              label="Ver presupuesto"
              className="budget-redirect-button text-base white-space-nowrap header-client-button"
              icon="pi pi-wallet text-xl"
              onClick={() => {
                navigate(AppRoutes.clientes.presupuestoCliente, {
                  state: {
                    ...selectedClient,
                  },
                })
              }}
            />
          </>
        )
      }
    />
  )
}

export default FormHeaderClient
